import { createEvent, createStore, restore, sample } from 'effector'
import { createGate } from 'effector-react'
import { fx } from 'src/libs'
import {
  NotificationPayload,
  showNotification,
} from 'src/features/notifications'

import { BASE_URL } from 'src/pages/worldCup2026/const'
import { AddTicketsRequest, Ticket, TicketsResponse } from './types'

export const TicketListGate = createGate()

export const changeStatusSubmit = createEvent<{
  userID: number
}>()

export const getTicketsFx = fx<void | any, TicketsResponse>({
  method: 'GET',
  url: `${BASE_URL}tickets/issue`,
})

export const changeStatusFx = fx<any, void>({
  method: 'POST',
  url: `${BASE_URL}tickets/issue`,
})

export const addTicketsFx = fx<AddTicketsRequest, void>({
  method: 'POST',
  url: `${BASE_URL}tickets/reserve`,
})

export const $tickets = createStore<Ticket[]>([]).on(
  getTicketsFx.doneData,
  (_, res) => res.body.items,
)

sample({
  clock: [TicketListGate.open, changeStatusFx.doneData],
  fn: () => ({}),
  target: getTicketsFx,
})

sample({
  clock: addTicketsFx.done,
  source: $tickets,
  fn: (ticketList, { params }) => {
    const body = params?.body
    if (!body) return ticketList
    const { ticketID, userID } = body
    return [...ticketList, { ticketID, userID, isUsed: false }]
  },
  target: $tickets,
})

sample({
  clock: changeStatusSubmit,
  fn: ({ userID }) => ({
    url: `${BASE_URL}tickets/issue`,
    body: { userID },
  }),
  target: changeStatusFx,
})

sample({
  clock: [
    getTicketsFx.failData,
    changeStatusFx.failData,
    addTicketsFx.failData,
  ],
  fn: (error): NotificationPayload => ({
    type: 'error',
    message: 'Request failed',
    description: error?.body?.message ?? 'Request failed',
  }),
  target: showNotification,
})

sample({
  clock: changeStatusFx.doneData,
  fn: (): NotificationPayload => ({
    type: 'success',
    message: 'Success',
    description: 'Ticket successfully issued',
  }),
  target: showNotification,
})

sample({
  clock: addTicketsFx.doneData,
  fn: (): NotificationPayload => ({
    type: 'success',
    message: 'Success',
    description: 'Ticket added successfully',
  }),
  target: showNotification,
})
